export default {"src":"/_next/static/media/sales-bill-disc.876f722d.svg","height":432,"width":552};